// Production URL for API

export const ApiUrl = "https://cms.lourdesshrineperambur.org/api";

// Development URL for API

// export const ApiUrl = "http://127.0.0.1:8000/api";